import React from 'react'
import PropTypes from 'prop-types'

import TextField from 'material-ui/TextField/TextField'

export default class CompanyFieldInput extends React.Component {

  static propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    hintText: PropTypes.string.isRequired,
    errorText: PropTypes.string,
    onTextChanged: PropTypes.func.isRequired,
    onEnterPressed: PropTypes.func.isRequired
  }

  handleTextChanged = event => {
    event.preventDefault()
    this.props.onTextChanged(event.target.value)
  }

  handleKeyDown = event => {
    if (event.keyCode === 13) {
      this.props.onEnterPressed()
    }
  }

  focus = () => {
    if (this.input) {
      this.input.focus()
    }
  }

  render() {
    return (
      <TextField
        id={this.props.id}
        ref={input => this.input = input}
        style={{ width: 200 }}
        inputStyle={styles.input}
        errorText={this.props.errorText}
        disabled={this.props.disabled}
        floatingLabelFocusStyle={{color: '#527da3'}}
        underlineFocusStyle={{ borderColor: '#527da3'}}
        hintText={this.props.hintText}
        hintStyle={styles.hint}
        onKeyDown={this.handleKeyDown}
        onChange={this.handleTextChanged} />
    )
  }

}

const styles = {

  input: {
    color: '#4a4a4a',
    fontSize: 14,
    fontWeight: 300,
    fontFamily: 'Roboto'
  },

  hint: {
    color: 'rgba(155, 155, 155, 0.5)',
    fontSize: 14,
    fontWeight: 300,
    fontFamily: 'Roboto'
  }

}



// WEBPACK FOOTER //
// ./src/login/CompanyFieldInput.js